import * as React from 'react'
import { inject, observer } from 'mobx-react'
import { PrintingConfigViewV2 } from './v2'
import { CurrentCompanyStore } from '../../../stores/CurrentCompanyStore'

interface Props {
  currentCompanyStore?: CurrentCompanyStore
  location: any
}

@inject('currentCompanyStore')
@observer
export class PrintingConfigView extends React.Component<Props, {}> {
  render() {
    return <PrintingConfigViewV2 location={this.props.location} />
  }
}
